import { Component, OnInit } from '@angular/core';
import { GamesGroupService, IPollQuestion } from '@fgb/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'fgb-polls-page',
  templateUrl: './polls-page.component.html',
  styleUrl: './polls-page.component.scss',
})
export class PollsPageComponent implements OnInit {
  pollsQuestion$: Observable<IPollQuestion[]>;

  constructor(private gamesGroupService: GamesGroupService) {}

  ngOnInit(): void {
    this.pollsQuestion$ = this.gamesGroupService.fetchPolls();
  }
}
